export default __webpack_public_path__ + "static/media/available-for-collection.90c91f9b.svg";